import { ComponentProps, JSXElementConstructor } from 'react';
import {
  Modal,
  registerModals,
  registerNavigationHandlers,
  NavigationConfig,
} from '@betty/navigation';
import { InboxModal } from '../modals';
import { InboxScreen } from '../screens';
import InboxModalHeader from '../components/InboxModalHeader';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [],
  FULL_SCREEN_MODALS: [
    {
      name: 'InboxModal',
      options: {
        header: () => <InboxModalHeader />,
      },
      component: InboxScreen,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const modals = {
  Inbox: InboxModal,
};

registerModals('inbox', modals);

registerNavigationHandlers<AppNavigatorParamsList, 'InboxModal'>({
  InboxModal() {
    Modal.open({ namespace: 'inbox', type: 'Inbox' });
  },
});

declare global {
  interface RegisteredModals {
    inbox: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
